import { createParagraph } from '@lumapps/wrex-typography/utils/createParagraph';

import { DEFAULT_INFO_PANEL_KIND, INFO_PANEL } from '../constants';
import { InfoPanelElement } from '../types';

/** Create a wrex info panel element. Its content is always wrapped in paragraphs (like the quote block). */
export function createInfoPanel(children: InfoPanelElement['children'] = [createParagraph()]): InfoPanelElement {
    return { type: INFO_PANEL, kind: DEFAULT_INFO_PANEL_KIND, children };
}
